import React from "react";
import "../styles/contact.css";

export default function Kontakt() {
  return (
    <div className="contact-page">
      <section className="contact-header">
        <h1>Kontakt</h1>
        <p>
          Imaš pitanje, želiš suradnju ili jednostavno podijeliti svoj
          bezglutenski recept? Veselim se tvojoj poruci!
        </p>
      </section>

      <section className="contact-wrapper">
        <div className="contact-info">
          <div className="contact-item">
            <h2>Email</h2>
            <p>
              <a href="mailto:info@slatkobezglutena.com">
                info@slatkobezglutena.com
              </a>
            </p>
          </div>

          <div className="contact-item">
            <h2>Lokacija</h2>
            <p>Rijeka</p>
          </div>

          <div className="contact-item">
            <h2>Društvene mreže</h2>
            <div className="footer-socials">
              <a
                href="https://www.instagram.com/tamara_whatsfordessert/?ref=badge"
                target="_blank"
                rel="noreferrer"
                className="social insta"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100063697717720"
                target="_blank"
                rel="noreferrer"
                className="social fb"
              >
                Facebook
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
